import { Client } from '../../pages/Details/types';

export type NewClientType = Omit<Client, '__typename' | 'clientId'> & {
  clientId?: string;
};

export enum ClientModalType {
  EditContact = 'edit-client-contact-modal',
  CreateEdit = 'create-edit-client-modal',
  DeleteContact = 'delete-client-contact-modal',
}
